/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import TextArea from '../../fields/TextArea';
import Button from '../../fields/Button';
import { GLOBAL_VARIABLES } from '../../../../utilites/variables';
import allActions from '../../../../Store/action';
import { useDispatch, useSelector } from 'react-redux';
import MultipleCheckLabelSelector from '../../fields/MultipleCheckLabelSelector';
import { HandleFormData } from '../../../../utilites';

const ExpensesSummary = () => {
	// ---------------------------------------
	// Variables , States & Store States
	// ---------------------------------------
	//
	const dispatch = useDispatch();

	const { expensesSummary, possibleExpenses } = GLOBAL_VARIABLES;
	const uploadFormData = HandleFormData({ parentIndex: 3, myIndex: 0 });

	const [{ taxPayerFormData, taxPayerForm, formInformation }] = useSelector((state) => [state.taxForms]);

	// For Text Input Field

	const [comments, setComments] = useState('');

	// For Choice Questions

	const [expensesOptions, setexpensesOptions] = useState([]);

	// For Choice Questions
	const [appliedOptions, setAppliedOptions] = useState([]);

	const [errors, setErrors] = useState({}); // Track errors for form fields

	// ---------------------------------------
	// HOOKS TO STORE DATA
	// ---------------------------------------
	useEffect(() => {
		setexpensesOptions(JSON.parse(JSON.stringify(expensesSummary)));
	}, []);
	// SAVE VALUES TO STATES
	useEffect(() => {
		if (taxPayerForm?.data?.expensesSummaryForm) {
			if (Object.keys(taxPayerForm?.data?.expensesSummaryForm).length === 0) return;

			const { expensesOptions, appliedOptions, comments } = taxPayerForm?.data?.expensesSummaryForm;
			setexpensesOptions(expensesOptions);
			setAppliedOptions(appliedOptions);
			setComments(comments);
		}
	}, [taxPayerForm?.data?.expensesSummaryForm]);

	// ---------------------------------------
	// Functions
	// ---------------------------------------

	const handleAppliedOptions = (option) => {
		const localOptions = appliedOptions.slice();
		if (localOptions?.includes(option)) {
			setAppliedOptions(localOptions.filter((data) => data !== option));
		} else {
			localOptions.push(option);
			setAppliedOptions(localOptions);
		}
	};
	const handleQuestions = (index, bool) => {
		const localexpensesOptions = expensesOptions.slice();
		localexpensesOptions[index].bool = bool;
		setexpensesOptions(localexpensesOptions);
	};

	const check_Validity = () => {
		setErrors({});
		const newErrors = {};

		// Add more validation rules as needed for other fields
		if (
			expensesOptions
				?.flatMap((data) => {
					return data?.bool;
				})
				.includes(null)
		) {
			newErrors.AnswerOtherQuestions = 'Please Select Required Option';
		}

		// Add more validation rules as needed for other fields
		if (appliedOptions?.length === 0 && expensesOptions[0].bool === true) {
			newErrors.AnswerOtherQuestions = 'Please Select Required Option';
		}

		setErrors(newErrors);

		let ConditionCheck = Object.keys(newErrors).length === 0 ? false : true;
		// Check if there are any errors
		return ConditionCheck;
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		let errors = check_Validity();
		if (errors) return;

		let FormObj = {
			expensesOptions,
			appliedOptions,
			comments,
		};

		let formData = taxPayerForm;
		taxPayerForm.data.expensesSummaryForm = FormObj;
		dispatch(allActions.taxForms.StoreFormData({ formData }));

		uploadFormData(formData);
	};

	const goBack = () => {
		// CHANGE FORM TO BACK
		let parentIndex = 3;
		let myIndex = 0;
		dispatch(allActions.taxForms.moveToBack({ parentIndex, myIndex, taxPayerFormData }));
	};
	return (
		<form className="w-100 mt-3" onSubmit={handleSubmit}>
			<div className="mt-3 row justify-content-between px-3 custom-left-form">
				<p className="fw-bold">Expenses Summary</p>
				<div className=" mb-3 px-3">
					{expensesOptions?.map((data, i) => {
						return (
							<div key={i} className="w-100  align-items-center justify-content-between mt-2">
								<small className="col-md-12 form-check-label text-start" htmlFor={`checkbox-${i}`}>
								{data.question}{data.bool===null&&<span className='text-danger small-text mx-1'>*Required</span>}
								</small>
								<div className="col-md-12">
									<input
										onChange={() => handleQuestions(i, true)}
										checked={data?.bool === true}
										className="form-check-input"
										type="radio"
										id={`checkbox-${i + 178}`}
										name={`checkbox-${i}`}
									/>
									<label htmlFor={`checkbox-${i + 178}`} role="button" className="px-3 m-0 small">
										Yes
									</label>
									<input
										onChange={() => handleQuestions(i, false)}
										checked={data?.bool === false}
										className="form-check-input"
										type="radio"
										id={`checkbox-${i + 999}`}
										name={`checkbox-${i + 999}`}
									/>
									<label htmlFor={`checkbox-${i + 999}`} role="button" className="px-3 m-0 small">
										No
									</label>
								</div>
							</div>
						);
					})}
				</div>
			</div>
			<hr />
			{expensesOptions[0]?.bool !== true &&
				possibleExpenses?.map((data, index) => {
					return (
						<li className="mx-3 text-muted">
							<small>{data.question}</small>
						</li>
					);
				})}
			{expensesOptions[0]?.bool === true && (
				<MultipleCheckLabelSelector
					col={12}
					mapData={possibleExpenses}
					selectedOptions={appliedOptions}
					handleAppliedOptions={handleAppliedOptions}
					label={'Select all that apply to this person'}
				/>
			)}
			<br />
			<small className="ml-4 fw-bold">Comments</small>
			<hr className="m-0" />
			<div className="mt-3 row justify-content-between px-3 mb-3 custom-left-form">
				<small className="text-dark fw-bold m-0 py-2">
					Enter Any Additional Information / Question here.
				</small>
				<div className="col-md-8 mb-3">
					<TextArea
						inputName="form-control"
						defaultValue={comments}
						placeholder="Comments"
						name="comments"
						fn={setComments}
						row="6"
						required={false}
					/>
				</div>
			</div>
			{Object.keys(errors)
				?.map((key) => {
					return errors[key];
				})
				?.map((data, index) => {
					return (
						<>
							<small className="text-primary" key={index}>
								{data}*
							</small>
							<br />
						</>
					);
				})}
			<div className="container-fluid content-row pb-4">
				<div className="d-flex align-items-center justify-content-center row">
					<Button
						mainClass="btn btn-info custon-button-text  w-100 text-dark"
						buttonText="Previous"
						wrapperClass={'w-25 custon-button  mt-4'}
						type="button"
						callback={() => goBack()}
					/>
					<Button
						mainClass="btn btn-primary custon-button-text   w-100"
						buttonText="Next"
						wrapperClass={'w-25 custon-button  mt-4'}
						type="submit"
						disabled={!formInformation?.lead_id}
					/>
				</div>
			</div>
		</form>
	);
};

export default ExpensesSummary;
